module.exports = __webpack_public_path__ + "static/the-famous-five-collection-1-551d5ffef8a85e4684dfaa151fd6a0a8.jpg";